<template>
  <div class="fullPageShimmer" v-if="menuShimmer">
    <div class="pt16">
      <div class="plr16">
        <div
          class="hide-shimmer-text shimmer-container br8 rounded width100"
          :style="{ height: '40px' }"
        >
          random
        </div>
      </div>
      <div class="plr16">
        <div
          class="hide-shimmer-text shimmer-container rounded br8 width100 mt16"
          :style="{ height: '40px' }"
        >
          random
        </div>
      </div>
      <div
        class="hide-shimmer-text w100 mb8 p5 mt16"
        :style="{ background: '#F4F4F4', height: '200px' }"
      >
        random hero image
      </div>
      <div class="plr16">
        <div
          class="hide-shimmer-text shimmer-container rounded br8 width100 mt20"
          :style="{ height: '300px' }"
        >
          random
        </div>
      </div>
      <div class="plr16">
        <div
          class="hide-shimmer-text shimmer-container rounded br8 width100 mt20"
          :style="{ height: '300px' }"
        >
          random
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "MenuPageShimmer",
  computed: {
    menuShimmer() {
      return this.$store.state.ProductItems.menuShimmer;
    },
  },
};
</script>
